import {keepPreviousData, useQuery} from "@tanstack/vue-query";
import {PublicApi} from "~/gen/openapi/portalService";

export const usePrivacyInformationService = () => {
    const { $axios, $config } = useNuxtApp()
    const publicApi = new PublicApi(undefined, $config.public.apiBaseHost, $axios)

    const privacyPolicyQueryOptions = {
        queryKey: ['publicGetPrivacyPolicy'],
        queryFn: async () => {
            try {
                //@ts-expect-error api spec lies
                return (await publicApi.publicGetPrivacyPolicy())?.data?.maintext
            } catch (error) {
                console.error(error)
                return Promise.reject(error)
            }
        },
        staleTime: 60*60*1000,
        refetchOnWindowFocus: false,
        placeholderData: keepPreviousData,
    }

    const privacyPolicyQuery = () => useQuery(privacyPolicyQueryOptions)

    return {
        privacyPolicyQueryOptions,
        privacyPolicyQuery,
    }
}